import { render } from "./RemoveAccountForm.vue?vue&type=template&id=58dac638"
import script from "./RemoveAccountForm.vue?vue&type=script&lang=js"
export * from "./RemoveAccountForm.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__